<template>
   <div class="global-notification">
    <div @click.prevent="back()" class="global-notification__bg"></div>
    <div class="global-notification__box">
        <a href="#" @click.prevent="back()" class="global-notification__close">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 17C13.4 17 17 13.4 17 9C17 4.6 13.4 1 9 1C4.6 1 1 4.6 1 9C1 13.4 4.6 17 9 17Z" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.73633 11.2639L11.2643 6.73596" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11.2643 11.2639L6.73633 6.73596" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </a>
        <div class="global-notification__title">
            {{ title }}
        </div>
        <div class="global-notification__message">
          <p v-html="message"></p>
        </div>
        <div class="global-notification__button">
           <ButtonSecondary
            :title="$store.getters.language.back"
            @buttonClick="back()"
          />
           <ButtonPrimary
            :title="$store.getters.language.remove"
            @buttonClick="remove()"
          />
        </div>
    </div>
   </div>
</template>

<script>
import ButtonPrimary from "../../components/global/ButtonPrimary"
import ButtonSecondary from "../../components/global/ButtonSecondary"

export default {
    name: 'ConfirmNotification',
    data: () => ({
    }),
    props: {
        message: {
            type: String,
            default: 'It looks like something went wrong. If you need help, you can reach out to us through the chat function.'
        },
        title: {
            type: String,
            default: 'OOOPS!'
        }
    },
    components: {
        ButtonPrimary,
        ButtonSecondary
    },
    computed: {
    },
    mounted() {
    },
    created() {
    },
    methods: {
        back () {
            this.$emit('back')
        },
        remove () {
            this.$emit('remove')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../scss/global/includes";

    .global-notification {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 10007;
    }
    .global-notification__bg {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 10007;
        background: rgba(0,0,0,0.2);
        cursor: pointer;
    }
    .global-notification__box {
        position: fixed;
        top: 50%;
        left: 50%;
        width: 480px;
        max-width: 100%;
        transform: translate(-50%, -50%);
        text-align: center;
        z-index: 10008;
        background: #FFFFFF;
        border-radius: 4px;
        padding: 90px;
        display: flex;
        gap: 24px;
        flex-wrap: wrap;
        @include breakpoint(tablet) {
            padding: 60px 45px;
        }
    }
    .global-notification__button {
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center; 
        gap: 4px;
    }
    .global-notification__title {
        width: 100%;
        @include responsive-text-size('Header--16--BOLD');
    }
    .global-notification__message {
        width: 100%;
    }
    .global-notification__close {
        position: absolute;
        top: 8px;
        right: 8px;
    }
</style>
